var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"data-name":"レイヤー 1","id":"レイヤー_1","viewBox":"0 0 6 6.93","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"data-name":"レイヤー 2","id":"レイヤー_2"}},[_c('g',{attrs:{"id":"text"}},[_c('polygon',{staticStyle:{"fill":"var(--v-secondary-base)"},attrs:{"points":"6 3.46 0 0 0 6.93 6 3.46"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }